import { takeLatest, put, call } from 'redux-saga/effects';

import { listMensagemFiscal } from '../service';
import {
  TABLE_MENSAGEM_FISCAL,
  TABLE_MENSAGEM_FISCAL_PENDING,
  TABLE_MENSAGEM_FISCAL_SUCCESS,
  TABLE_MENSAGEM_FISCAL_FAILURE
} from '../actionTypes';

function* sagaListMensagemFiscal(action) {
  yield put({ type: TABLE_MENSAGEM_FISCAL_PENDING })

  try {
    const table = yield call(listMensagemFiscal, action.args)
    yield put({ type: TABLE_MENSAGEM_FISCAL_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_MENSAGEM_FISCAL_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListMensagemFiscal() {
  yield takeLatest(TABLE_MENSAGEM_FISCAL, sagaListMensagemFiscal)
}